import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import Heading from '@atlaskit/heading';
import { Box, xcss } from '@atlaskit/primitives';
import { BreadcrumbRenderer } from '@atlassian/jira-breadcrumbs/src';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';
import { PageTopBar } from '@atlassian/jira-horizontal-nav-page-topbar';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

type Props = {
	actions?: ReactNode;
};

const TitleBreadcrumbs = ({ actions }: Props) => {
	const breadcrumbs = <BreadcrumbRenderer />;
	const { formatMessage } = useIntl();

	return (
		<PageTopBar truncateTitle disableTitleStyles breadcrumbs={breadcrumbs} actions={actions}>
			<TitleContainer>
				<Heading size="large" as="div">
					<Box xcss={pageTitleStyles}>{formatMessage(messages.title)}</Box>
				</Heading>
			</TitleContainer>
		</PageTopBar>
	);
};

export default TitleBreadcrumbs;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TitleContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${gridSize * 4}px`,
});

const pageTitleStyles = xcss({
	marginTop: 'space.0',
});
